
  import { defineComponent } from 'vue';

  import constants from '@/common/constants';

  import AdditionalUploadingTemplate from '../components/additional-uploading/AdditionalUploadingTemplate.vue';
  import { UploadingDataStatusTypes } from '../types/calculation-common';

  export default defineComponent({
    name: 'AdditionalUploading',
    components: {
      AdditionalUploadingTemplate,
    },
    computed: {
      getPermissionCode() {
        return constants.Permissions.VedAdditionalUploadingView;
      },
      getType(): UploadingDataStatusTypes {
        return UploadingDataStatusTypes.ADDITIONAL_UPLOADING;
      },
    },
  });
